import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import Card from '../card';
import Wallet from '../wallet';
import MGV from '../mgv';
import Upi from '../upi';
import Nb from '../nb';
import Btn from '../btn';
import SC from '../sc';
import PPB from '../ppb';
import PDC from '../postpaid';
import EMI from '../emi';
import UPIPUSH from '../upipush';
import BankMandate from '../bank-mandate';
import SavedBankMandate from '../savedBankMandate';
import Overlay from '../overlaybox';
import LOCALE from '../../locale/en';
import LOGIN from '../LoginComponent/loginComponent';
import { onChange } from '../../common/actions';
import {
  isInsufficientBalance,
  isMgvSufficient,
  getKey,
  clientMessage,
  calculateAmountPayable,
  isAddNPay,
  defaultSelected,
  equalsIgnoreCase,
  money,
  convertRupeeCharToUnicode,
  isFunction,
  isMobileDevice,
  commas,
  cloneObject
} from '../../utils/common';
import {
  ELEMENT_PAYMODE,
  EMI_SUBVENTION_STRATEGY,
  PAYMENT_FLOW,
  PAYMODE,
  TOKEN
} from '../../../../common/src/constant';
import CONSTANT, { CACHE, GLOBAL_STORE } from '../../utils/constants';
import { EVENT, log } from '../../common/logger';
import Footer from '../footer';
import Header from '../header';
import { Timeout } from '../timeOut';
import OverlayWrap from '../OverlayWrap';
import CvvHelper from '../CvvHelper';
import Details from '../subscription/details';
import { FLOW as _FLOW } from '../../../../common/index.api';
import { fetchPcfForPayMode, isPcfEnabled, updatedPcfAmountAndReturn } from '../../controllers/pcf';
import QRCode from '../qr';
import Offers from '../offers';
import {
  isPromoAvailable,
  applyPromo,
  parseApplyPromoResponse,
  handleApplyPromoError,
  getSimplifiedPaymentOffers
} from '../../controllers/offers';
import { globaleStore } from '../../common/cache';
import { updateOnNewFPO } from '../../controllers/switch-user';
import ElementsHeader from '../elements-header';
// import DirectBank from '../directBank';

class Home extends Component {
  inProcessPcf = null;

  hiddenInputRef = '';

  constructor(props) {
    super(props);
    this.selected = undefined;
    this.idPayBankValidateDisabled = false;
    const paymentOptions = this.props.cache.getData('paymentOptions');

    this.state = {
      upiIntentApps: [],
      showAllSavedCards: false,
      headerFixClass: '',
      pcfFeeAmount: 0,
      isPcfEnabled: isPcfEnabled(this.props.cache),
      isPromoAvailable: false,
      payModeBasedOffers: null,
      mandateAccountDetails: getKey(paymentOptions, 'mandateAccountDetails', null),
      qr:
        equalsIgnoreCase(this.props.checkoutElementPayMode, ELEMENT_PAYMODE.SCAN_AND_PAY) ||
        !getKey(this.props, 'loginInfo.userLoggedIn')
          ? getKey(this.props.cache.getData('paymentOptions'), 'qrDetail')
          : null
    };
    this.updatePromoEnableStatus();
    this.onBtnClick = this.onBtnClick.bind(this);
    this.amountPayable = calculateAmountPayable(
      this.props.cache.getData(CONSTANT.TXN_AMOUNT),
      this.props.wallet,
      true,
      this.props.subscription
    );
    window.upiIntent = {};
    window.upiIntent.setUpiIntentApps = this.setUpiIntentApps.bind(this);
    // this.setUpiIntentApps({
    //   Paytm: 'net.one97.paytm',
    //   Airtel: 'net.one97.payt',
    //   BHIM: 'net.one97.patm',
    //   PhonePe: 'net.one97.pytm',
    //   Google: 'net.one97.aytm',
    //   Samsung: 'net.one97paytm',
    //   Axis: 'net.one9.paytm'
    // });
    this.showMoreSavedCardsLinkTxt = LOCALE.savedCard['label.viewMore'];
    this.firstPreferredPayment = '';
    this.label = clientMessage(CONSTANT.STATIC.toLowerCase(), this.props.cache).label;
    this.isWeb = !isMobileDevice();
    this.setSinglePaymodeSingleSelection(this.props);
  }

  components = {
    ppbl: PPB,
    pdc: PDC,
    card: Card,
    nb: Nb,
    sc: SC,
    wallet: Wallet,
    mgv: MGV,
    emi: EMI,
    // cod: COD,
    upi: Upi,
    upipush: UPIPUSH,
    login: LOGIN,
    BANK_MANDATE: BankMandate,
    sbm: SavedBankMandate
    // ada: ADA,
    // aoa:AOA,
  };

  updatePaymentDataOnFPOUpdate = () => {
    let lastFPOResponse = null;
    this.globaleStoreSubs = globaleStore.subscribe(state => {
      try {
        let newFPOResponse = state[GLOBAL_STORE.FPO_UPDATED_RESPONSE];
        if (newFPOResponse !== lastFPOResponse) {
          newFPOResponse = cloneObject(newFPOResponse);
          const { onSelectChange, onLoginDataChange, onBtnTextChange } = this.props;
          updateOnNewFPO(
            newFPOResponse,
            this.props.cache,
            this.props.checkoutElementPayMode,
            this.props.subscription,
            {
              onSelectChange,
              onLoginDataChange,
              onBtnTextChange
            }
          );
          lastFPOResponse = newFPOResponse;
        }
      } catch (ex) {}
    });
    this.props.cache.setData(CACHE.GLOBAL_STORE_UNSUBSCRIPTION, this.globaleStoreSubs);
  };

  componentWillUnmount() {
    this.globaleStoreSubs && this.globaleStoreSubs();
    this.props.cache.setData(CACHE.GLOBAL_STORE_UNSUBSCRIPTION, null);
  }

  componentDidMount() {
    this.props.checkoutElementPayMode && this.updatePaymentDataOnFPOUpdate();
    const config = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    const paymentOptions = this.props.cache.getData('paymentOptions');
    const txnAmount = this.props.cache.getData(CONSTANT.TXN_AMOUNT);
    this.props.selected && this.onOptionSelect(this.props.selected, true);
    this.amountPayable = calculateAmountPayable(
      txnAmount,
      this.props.wallet,
      true,
      this.props.subscription
    );
    let payAmountText = LOCALE.payButton.text + this.amountPayable;
    if (
      isAddNPay(paymentOptions, this.props.cache) &&
      getKey(this.props, 'selected.type') !== 'mgv'
    ) {
      const addNPayText = LOCALE.payButton.addNPayText;
      payAmountText = addNPayText.replace('amount', this.amountPayable);
    }
    if (
      getKey(this.props.selected, 'type', '') === 'login' ||
      getKey(this.props.selected, 'type', '') === CONSTANT.BANK_MANDATE_PAY_TYPE ||
      getKey(this.props.selected, 'type', '') === CONSTANT.SAVED_BANK_MANDATE_PAY_TYPE
    ) {
      /*
       * if selected component is login then change btn text to proceed instead of pay
       * */
      const locale = clientMessage(CONSTANT.LOGIN.toLowerCase(), this.props.cache);
      this.props.onBtnTextChange(locale.label.btnSendOtpText);
    } else {
      this.props.onBtnTextChange(payAmountText);
    }

    this.mainComp.addEventListener(
      'scroll',
      e => {
        if (
          getKey(e, 'srcElement') &&
          getKey(this.headerComp, '_component.headerElem.clientHeight')
        ) {
          if (e.srcElement.scrollTop >= this.headerComp._component.headerElem.clientHeight) {
            if (!this.state.headerFixClass) {
              this.setState({ headerFixClass: 'ptm-header_fix' });
            }
          } else if (this.state.headerFixClass) {
            this.setState({ headerFixClass: '' });
          }
        }
      },
      false
    );

    setTimeout(
      this.handleSelfExpiration.bind(this),
      config.expireDuration || 3600000,
      Date.now(),
      config.expireDuration
    );
    const retryData = this.props.cache.getData(CACHE.RETRY_DATA);
    if (retryData) {
      this.props.cache.getData(CACHE.STORE).setState({
        retryMessage: retryData.retryErrorMsg || CONSTANT.GENERIC_ERROR,
        overlayValue: CONSTANT.RETRY
      });
    }
    if (this.props.selected && this.props.cache.getData(CONSTANT.STORAGE_USED)) {
      this.mainComp.scrollBy(0, this.props.selected.reference.base.offsetTop - 100);
    }
  }

  handleSelfExpiration = () => {
    // if (Math.abs(time - Date.now()) > duration) {
    //
    // }
    log({ eventType: EVENT.APP_AUTO_CLOSE });
    const notifyMerchant = getKey(
      this.props.cache.getData(CACHE.MERCHANT_CONFIG),
      'handler.notifyMerchant',
      undefined
    );
    if (Object.prototype.toString.call(notifyMerchant) === '[object Function]') {
      notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.PAYMENT_ERROR, {
        message: 'Auto closed App'
      });
    }

    const closeHandler = this.props.cache.getData(CACHE.CLOSE_HANDLER);
    isFunction(closeHandler) && closeHandler();
  };

  setUpiIntentApps = packageNames => {
    const appObj = JSON.parse(packageNames);
    if (appObj) {
      const map = [];
      for (const app in appObj) {
        if (Object.prototype.hasOwnProperty.call(appObj, app)) {
          map.push({
            name: app.split(' ').length > 2 ? app.split(' ')[1] : app.split(' ')[0],
            displayName: app,
            packageName: appObj[app]
          });
        }
      }
      this.setState({ upiIntentApps: map });
    }
  };

  onBtnClick = e => {
    e.preventDefault();

    if (getKey(this.state.payModeBasedOffers, 'hasValidationError', false)) {
      this.props.onHighlightOfferError(true);
      setTimeout(() => {
        this.props.onHighlightOfferError(false);
      }, 1000);
      return;
    }

    log({
      eventType: EVENT.BUTTON_CLICK,
      payMode: this.props.selected && this.props.selected.paymentMode
    });
    if (this.props.selected && this.props.selected.paymentMode === PAYMODE.LOGIN) {
      this.callComponentSubmit();
    } else {
      const merchantConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
      if (merchantConfig.flow === _FLOW.DEFERRED) {
        this.handleTokenForDeferredFlow();
      } else {
        this.callComponentSubmit();
      }
    }
  };

  handleTokenForDeferredFlow = () => {
    const emiPlans = this.props.cache.getData(CACHE.EMI_PLANS);
    const paymentIntent = this.props.cache.getData(CACHE.PAYMENT_INTENT);
    let paymentIntents = [];
    // if paymode is emi or sc used the payment intent stored in cache or create new one
    if (
      this.props.selected.name === PAYMODE.EMI ||
      (this.props.selected.type === 'sc' && emiPlans)
    ) {
      paymentIntents = paymentIntent;
    } else {
      const txnAmount = this.props.cache.getData(CONSTANT.TXN_AMOUNT);
      if (this.props.wallet && this.props.wallet.isUsed) {
        paymentIntents.push({
          mode: PAYMODE.WALLET,
          txnAmount:
            parseFloat(this.props.wallet.walletBalance) >= parseFloat(txnAmount)
              ? txnAmount
              : this.props.wallet.walletBalance
        });
      }
      const intent = this.createPaymentIntentObject();
      if (intent) {
        paymentIntents.push(intent);
      }
    }

    this.props.cache.setData(CACHE.PAYMENT_INTENT, paymentIntents);
    // let tokenData = cache.getData(CACHE.TOKEN_DATA);
    // let config = cache.getData(CACHE.MERCHANT_CONFIG);

    this.callComponentSubmit();
  };

  callComponentSubmit = () => {
    const paymentOption = this.props.cache.getData('paymentOptions');
    const insufficientBalance = isInsufficientBalance(paymentOption, this.props.cache);
    if (!this.selected && !insufficientBalance && this.props.wallet && this.props.wallet.isUsed) {
      this.props.wallet.reference._component.submit();
    } else if (this.selected) {
      (typeof this.selected._component.submit === 'function' &&
        this.selected._component.submit()) ||
        (typeof this.selected.submit === 'function' && this.selected.submit());
    } else if (!this.selected && this.props.selected) {
      typeof this.props.selected.reference._component.submit === 'function' &&
        this.props.selected.reference._component.submit();
    }
  };

  showHideSavedCards = () => {
    const showAllSavedCards = !this.state.showAllSavedCards;
    if (!showAllSavedCards) {
      this.showMoreSavedCardsLinkTxt = LOCALE.savedCard['label.viewMore'];
    } else {
      this.showMoreSavedCardsLinkTxt = LOCALE.savedCard['label.viewLess'];
    }
    this.setState(prevState => ({ showAllSavedCards: !prevState.showAllSavedCards }));
  };

  componentWillReceiveProps(nextProps) {
    if (
      getKey(this.props, 'loginInfo.userLoggedIn') !== getKey(nextProps, 'loginInfo.userLoggedIn')
    ) {
      this.setSinglePaymodeSingleSelection(nextProps);
      this.setState({
        qr:
          equalsIgnoreCase(this.props.checkoutElementPayMode, ELEMENT_PAYMODE.SCAN_AND_PAY) ||
          !getKey(nextProps, 'loginInfo.userLoggedIn')
            ? getKey(this.props.cache.getData('paymentOptions'), 'qrDetail')
            : null
      });
      this.updatePromoEnableStatus(null, nextProps.selected);
    }
  }

  updatePromoEnableStatus = (selected, nextSelectable) => {
    if (!getSimplifiedPaymentOffers(this.props.cache)) {
      this.setState({ isPromoAvailable: null, payModeBasedOffers: null });
      return;
    }

    const prevIsPromoAvailable = this.state.isPromoAvailable;
    const currentIsPromoAvailable = isPromoAvailable(this.props.cache);
    this.props.cache.setData(
      CONSTANT.TXN_AMOUNT,
      this.props.cache.getData(CONSTANT.UNMODIFIED_TXN_AMOUNT)
    );
    this.setState({
      isPromoAvailable: currentIsPromoAvailable,
      payModeBasedOffers: null
    });

    if (equalsIgnoreCase(getKey(nextSelectable, 'paymentMode'), PAYMODE.LOGIN)) {
      return;
    }

    if (prevIsPromoAvailable !== currentIsPromoAvailable) {
      selected && this.props.onSelectChange(null);
      setTimeout(() => {
        // Force re-render for opened paymode data update inorder prevent stale offer esp. in case of iframes
        selected && this.props.onSelectChange(selected);
        nextSelectable && this.applyPromoForPayMode(nextSelectable);
      }, 0);
    } else if (nextSelectable) {
      this.applyPromoForPayMode(nextSelectable);
    }
  };

  onOptionSelect = (option, isInitialSelection = false) => {
    this.props.cache.setData(CONSTANT.CURRENT_PAYMODE, option);
    // if same option is selected again, don't entertain
    if (!isInitialSelection && getKey(this.props, 'selected.id') === getKey(option, 'id')) {
      return;
    }

    /* if after validate emi paymode is changed set emi subvention token as null since on paymode change
     * emi subvention token is going in initiate txn call
     *  */

    if (this.props.cache.getData(CONSTANT.EMISUBVENTION_TOKEN)) {
      this.props.cache.setData(CONSTANT.EMISUBVENTION_TOKEN, null);
    }
    /* if  option is different from the selected set the emi plan in store to null */
    if (option && this.props.selected && option.id !== this.props.selected.id) {
      this.props.onSelectedPlan(null);
    }
    /* If flow type is deferred and paymode is changed delete current txn token and set  fallback sso token
     * as token type
     * */

    /* If payment option is being changed set the emi plan selected in cache to null */
    this.props.cache.setData(CACHE.EMI_PLANS, null);
    const fallBackAmount = this.props.cache.getData(CONSTANT.FALLBACK_TXN_AMOUNT);
    if (fallBackAmount) {
      this.props.cache.setData(CONSTANT.TXN_AMOUNT, fallBackAmount);
    }
    this.idPayBankValidateDisabled && this.props.onPayChange(true);
    const config = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    const fallbackTokenData = this.props.cache.getData(CACHE.FALLBACK_TOKEN_DATA);
    const tokenData = this.props.cache.getData(CACHE.TOKEN_DATA);

    if (tokenData.tokenType === TOKEN.TXN && config.flow === _FLOW.DEFERRED) {
      this.props.cache.setData(CACHE.TOKEN_DATA, {
        token: fallbackTokenData.token,
        tokenType: TOKEN.SSO
      });
    }

    // setting selected bank on option change to be included in defered flow
    this.props.cache.setData(CACHE.SELECTEDBANK, null);
    this.props.cache.setData(CACHE.CARD_DETAILS, null);
    let tempPaymode =
      getKey(option, 'paymentMode') || getKey(option, 'type') || getKey(option, 'id') || '';
    if (getKey(option, 'cardDetails.cardType')) {
      tempPaymode = `${tempPaymode}_${getKey(option, 'cardDetails.cardType')}`;
    }
    log({
      eventType: EVENT.SELECTED_PAYMODE,
      payMode: tempPaymode.toUpperCase()
    });
    if (!this.firstPreferredPayment) {
      this.firstPreferredPayment = option.displayName;
    }
    const paymentOptions = { ...this.props.cache.getData('paymentOptions') };
    const walletObj = { ...paymentOptions.wallet };
    const insufficientBalance = isInsufficientBalance(paymentOptions, this.props.cache);
    if (paymentOptions && paymentOptions.wallet) {
      if (!insufficientBalance) {
        walletObj.isUsed = false;
        this.props.onWalletToggle(walletObj);
      } else {
        this.handleHybridCasesForWallet(paymentOptions, option);
      }
    }

    paymentOptions.wallet = walletObj;
    this.props.cache.setData(CACHE.PAYMENT_OPTIONS, paymentOptions);
    const selectedType = getKey(this.props, 'selected.type', null);
    // this.props.onSelectChange(option);
    if (selectedType && selectedType === 'emi' && option.isEmiSc) {
      // in case of emi previously selected and option is sc on emi set subselected as sc
      const selected = { ...this.props.selected };
      selected.subOption = option;
      this.props.onSelectChange(selected);
      this.applyPromoForPayMode(
        selected,
        getKey(option, 'issuingBank'),
        null,
        null,
        getKey(option, 'cardDetails.cardId')
      );
    } else {
      this.props.onSelectChange(option);
      // Move to next event loop so that wallet correct used status is
      // available on immediate switching from wallet to other paymode.
      setTimeout(() => {
        this.fetchPcf(option);
      }, 0);
      this.applyPromoForPayMode(option);
    }
    // todo check for this usage
    // walletObj = { ...paymentOptions.wallet };
    // setTimeout(() => {
    //   scrollToSelectedOption(option);
    // }, 0);

    this.setPayableAmount(option, walletObj, paymentOptions);
  };

  applyPromoForPayMode = (paymode, channelCode, cardNumber, vpa, savedCardId) => {
    if (!this.state.isPromoAvailable) {
      return Promise.resolve();
    }

    this.setState({ payModeBasedOffers: {} });
    this.props.cache.setData(
      CONSTANT.TXN_AMOUNT,
      this.props.cache.getData(CONSTANT.UNMODIFIED_TXN_AMOUNT)
    );
    this.setPayableAmount();
    this.props.onPayChange(false);
    const mConfig = this.props.cache.getData(CACHE.MERCHANT_CONFIG);
    const customerId = getKey(mConfig, 'emiSubvention.customerId', null);

    return applyPromo(
      this.props.cache,
      paymode,
      channelCode,
      cardNumber,
      vpa,
      savedCardId,
      customerId
    )
      .then(response => response)
      .catch(() => null)
      .then(response => this.processPromoResponse(response, paymode));
  };

  processPromoResponse = (payModeBasedOffers, paymode) => {
    // Prevent in case of isPromoAvailable value changed to false before late apply api response.
    if (!this.state.isPromoAvailable) {
      this.props.onPayChange(true);
      return;
    }

    this.setState({ payModeBasedOffers });

    const totalCashbackAmount = Number(getKey(payModeBasedOffers, 'totalCashbackAmount', 0));
    const totalInstantDiscount = Number(getKey(payModeBasedOffers, 'totalInstantDiscount', 0));
    const txnAmount = Number(this.props.cache.getData(CONSTANT.UNMODIFIED_TXN_AMOUNT, 0));
    const isEmiSubventionFlow = this.props.cache.getData(
      CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW
    );
    const selectedType = getKey(this, 'props.selected.type', null);
    this.props.cache.setData(CONSTANT.BANK_OFFER_TXN_AMOUNT, null);
    if (isEmiSubventionFlow) {
      this.handleProcessPromoResponseForAceessToken(payModeBasedOffers, paymode);
    }
    // if selectedType is sc or emi then change the  update the cart or amount based on cashback/discount
    if (isEmiSubventionFlow && (selectedType === 'emi' || selectedType === 'sc')) {
      this.handleEmiSubventionAmount(totalInstantDiscount, txnAmount);
    }

    this.props.cache.setData(CONSTANT.TXN_AMOUNT, money(txnAmount - totalInstantDiscount));
    this.setPayableAmount(null, null, null, totalCashbackAmount);
    this.props.onPayChange(true);
  };

  handleProcessPromoResponseForAceessToken = (payModeBasedOffers, paymode) => {
    /*
   this is being done since in cache object we have offer against paymode but to be sent to
    merchant it has to be done the way received in response */
    const totalCashbackAmount = Number(getKey(payModeBasedOffers, 'totalCashbackAmount', 0));
    const totalInstantDiscount = Number(getKey(payModeBasedOffers, 'totalInstantDiscount', 0));
    const selected = getKey(this, 'props.selected', {});
    /* if paymode is available then choose paymode else choose selected for getting the key for which
     * offer object is stored against */
    let selectedPaymode = paymode
      ? (paymode.paymentMode || paymode.type).toUpperCase()
      : (selected.paymentMode || selected.type).toUpperCase();
    /* for card the selected paymode set in key is card and ot creditcard/debit card */
    if (selectedPaymode === CONSTANT.CC || selectedPaymode === CONSTANT.DC) {
      selectedPaymode = PAYMODE.CARD;
    }
    const offer = getKey(payModeBasedOffers, `offerBreakup.${selectedPaymode}`, {});
    delete offer.validationErrorMessage;
    const paymodeOffer = {
      offerBreakup: [offer],
      totalCashbackAmount,
      totalInstantDiscount
    };

    this.props.cache.setData(CONSTANT.PAYMODE_BASED_OFFER, paymodeOffer);
    const txnAmount = Number(this.props.cache.getData(CONSTANT.UNMODIFIED_TXN_AMOUNT, 0));
    const selectedType = getKey(this, 'props.selected.type', null);
    // if selectedType is sc or emi then change the  update the cart or amount based on cashback/discount
    if (selectedType === 'emi' || selectedType === 'sc') {
      this.handleEmiSubventionAmount(totalInstantDiscount, txnAmount);
    }

    this.props.cache.setData(CONSTANT.TXN_AMOUNT, money(txnAmount - totalInstantDiscount));
    this.setPayableAmount(null, null, null, totalCashbackAmount);
    this.props.onPayChange(true);
  };

  handlePromoResponseFromCard = (response, bankCode) => {
    const parsedResponse = parseApplyPromoResponse(this.props.cache, false, bankCode, response);
    this.processPromoResponse(parsedResponse);
  };

  handlePromoErrorFromCard = (error, payMethod, bankcode) => {
    const parsedResponse = handleApplyPromoError(this.props.cache, error, payMethod, bankcode);
    this.processPromoResponse(parsedResponse);
  };

  fetchPcf = (option, instId) => {
    let txnAmount = 0;
    let isWalletPayMode = false;

    // if selected option is login then no need to call fetch pcf for the selected paymode
    if (
      !option ||
      option.type === 'login' ||
      !this.state.isPcfEnabled ||
      (this.inProcessPcf &&
        this.inProcessPcf.option === option &&
        this.inProcessPcf.instId === instId) ||
      (!Object.prototype.hasOwnProperty.call(option, 'isWalletOnly') &&
        getKey(this.props, 'wallet.isUsed', false))
    ) {
      isWalletPayMode = option && Object.prototype.hasOwnProperty.call(option, 'isWalletOnly');
      return Promise.resolve();
    }

    if (isWalletPayMode && !option.isUsed) {
      this.updatePcfAmount(null, false);
      return Promise.resolve();
    }

    this.setState({ pcfFeeAmount: 0 });
    this.inProcessPcf = { option, instId };

    /* passing txn amount since in case of access token flow amount has to be passed in fetch pcf details */
    if (this.props.cache.getData(CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW)) {
      txnAmount = this.props.cache.getData(CONSTANT.TXN_AMOUNT);
    }
    return fetchPcfForPayMode(this.props.cache, option, instId, txnAmount)
      .then(pcf => {
        this.updatePcfAmount(pcf, false);
        this.inProcessPcf = null;
        const paymentOptions = this.props.cache.getData(CACHE.PAYMENT_OPTIONS);

        // Disable wallet and select new paymode if selected mode is wallet,
        // payment flow is none and wallet balance is less than pcf inclusive
        // txn amount.
        if (
          isWalletPayMode &&
          equalsIgnoreCase(getKey(paymentOptions, 'paymentFlow'), PAYMENT_FLOW.NONE) &&
          Number(this.props.cache.getData(CONSTANT.TXN_AMOUNT, 0)) >
            Number(getKey(option, 'walletBalance', 0))
        ) {
          this.disabledWalletAndSelectNewPaymode(paymentOptions);
        }
      })
      .catch(e => {
        this.updatePcfAmount(null, false);
        this.inProcessPcf = null;
        this.props.onNotificationTextChange(e && e.message);
      });
  };

  disabledWalletAndSelectNewPaymode(paymentOptions) {
    const wallet = { ...getKey(paymentOptions, 'wallet') };
    wallet.isUsed = false;
    wallet.isEnabled = false;
    this.props.onWalletToggle(wallet);

    const newSelected = defaultSelected(paymentOptions, this.props.cache);
    newSelected && this.onOptionSelect(newSelected);
  }

  updateSelectedPayModePcfWithInstId = instId => {
    // Delay to handle in case where option selection and
    // this function call happens at same time.
    setTimeout(() => {
      this.fetchPcf(this.props.selected, instId);
    }, 100);
  };

  setPayableAmount = (option, wallet, paymentOptions, cachback, useCachedCashbackValue = false) => {
    paymentOptions = paymentOptions || this.props.cache.getData('paymentOptions');
    wallet = wallet || this.props.wallet;
    option = option || this.props.selected;
    cachback = useCachedCashbackValue
      ? Number(getKey(this.state.payModeBasedOffers, 'totalCashbackAmount', 0))
      : cachback;

    if (equalsIgnoreCase(getKey(option, 'type'), PAYMODE.LOGIN)) {
      const locale = clientMessage(CONSTANT.LOGIN.toLowerCase(), this.props.cache);
      this.props.onBtnTextChange(locale.label.btnSendOtpText);
    } else {
      const amountPayable = calculateAmountPayable(
        this.props.cache.getData(CONSTANT.TXN_AMOUNT),
        wallet,
        false,
        this.props.subscription
      );

      let payAmountText = LOCALE.payButton.text + commas(amountPayable);

      if (isAddNPay(paymentOptions, this.props.cache) && (option && option.type !== 'mgv')) {
        payAmountText = LOCALE.payButton.addNPayText.replace('amount', commas(amountPayable));
      }

      const cachbackText = cachback
        ? convertRupeeCharToUnicode(
            LOCALE.payButton.effectivePrice
              .replace('amount', commas(cachback))
              .replace('effectPrice', commas(Number(amountPayable) - Number(cachback)))
          )
        : null;

      this.props.onBtnTextChange(payAmountText, cachbackText);
    }
    this.props.onPayChange(true);
  };

  updatePcfAmount = (pcf, isNotCalledFromFetchPcf = true) => {
    if (
      !this.state.isPcfEnabled ||
      (isNotCalledFromFetchPcf && getKey(this.props, 'wallet.isUsed', false))
    ) {
      return;
    }

    const pcfFeeAmount = updatedPcfAmountAndReturn(this.props.cache, pcf);
    this.setState({ pcfFeeAmount });
    this.setPayableAmount();
  };

  handleHybridCasesForWallet = (paymentOptions, option) => {
    if (paymentOptions.paymentFlow === PAYMENT_FLOW.HYBRID) {
      const walletObj = { ...paymentOptions.wallet };
      if (option.isHybridDisabled && walletObj && walletObj.isUsed) {
        walletObj.isUsed = false;
        walletObj.isEnabled = false;
        if (option.type === 'emi') {
          const locale = clientMessage(PAYMODE.EMI.toLowerCase(), this.props.cache);
          const text = locale.label.emiHybridDisabledText;
          this.props.onNotificationTextChange(text);
        }
      } else if (walletObj) {
        walletObj.isEnabled = !(!walletObj.isUsed && option.isHybridDisabled);
      }
      paymentOptions.wallet = walletObj;
      /* setting wallet obj in payment options to set wallet isUsed in cache for other use cases */
      this.props.cache.setData(CACHE.PAYMENT_OPTIONS, paymentOptions);
      walletObj && this.props.onWalletToggle(walletObj);
      const txnAmount = this.props.cache.getData(CONSTANT.TXN_AMOUNT);
      this.amountPayable = calculateAmountPayable(
        txnAmount,
        walletObj,
        true,
        this.props.subscription
      );
      const payAmountText = LOCALE.payButton.text + this.amountPayable;
      this.props.onBtnTextChange(payAmountText);
    }
  };

  createPaymentIntentObject = () => {
    const { wallet } = this.props;
    const txnAmount = this.props.cache.getData(CONSTANT.TXN_AMOUNT);
    const { selected } = this.props;
    // if selected doesnt have paymode return null
    if (!selected.paymentMode && selected.type !== 'sc') {
      return null;
    }
    const intent = {
      mode: selected.paymentMode || (selected.cardDetails && selected.cardDetails.cardType),
      txnAmount: wallet && wallet.isUsed ? txnAmount - this.props.wallet.walletBalance : txnAmount
    };

    if (selected.issuingBank || this.props.cache.getData(CACHE.SELECTEDBANK)) {
      intent.banks = [
        selected.issuingBank || this.props.cache.getData(CACHE.SELECTEDBANK).channelCode
      ];
    }

    if (selected && selected.paymentMode === PAYMODE.PAYMENT_BANK) {
      intent.mode = CONSTANT.NB;
      intent.banks = [CONSTANT.PPBL];
    }
    if (selected.cardDetails && selected.cardDetails.cardHash) {
      intent.cardHash = selected.cardDetails.cardHash;
    }

    // if new card is added get card hash and bank code stored in this.props.cache
    const cardDetails = this.props.cache.getData(CACHE.CARD_DETAILS);

    if (selected.type === 'card' && cardDetails) {
      const issuingBankCode = getKey(cardDetails, 'details.binDetail.issuingBankCode', null);
      intent.cardHash = cardDetails.cardHash;
      intent.banks = [issuingBankCode];
    }
    if (selected.channelCode) {
      intent.channels = [selected.channelCode];
    }
    // in case of pdc remove  bank
    if (selected.type === 'pdc') {
      delete intent.banks;
    }
    return intent;
  };

  setSinglePaymodeSingleSelection(props) {
    const balancePaymodeCount =
      getKey(props, 'loginInfo.userLoggedIn') && getKey(props, 'wallet') ? 1 : 0;
    let isSingleSelection = false;
    const checkoutElementPayMode = getKey(props, 'checkoutElementPayMode');
    if (
      (checkoutElementPayMode &&
        balancePaymodeCount +
          Number(Boolean(getKey(props, 'mgv.isEnabled'))) +
          getKey(props, 'payData.paymentModes', []).length +
          getKey(props, 'payData.savedVPas', []).length +
          getKey(props, 'payData.savedInstruments', []).length ===
          1) ||
      equalsIgnoreCase(ELEMENT_PAYMODE.EMI, checkoutElementPayMode)
    ) {
      isSingleSelection = true;
    }

    this.isSingleSelection = isSingleSelection;
    this.hidePaymodeLabel =
      isSingleSelection &&
      !(this.isWeb && getKey(this.state, 'qr.enabled') && getKey(this.state, 'qr.dataUrl')) &&
      Boolean(getKey(props.cache.getData(CACHE.MERCHANT_CONFIG), 'hidePaymodeLabel', false));
  }

  handleEmiSubventionAmount = (totalInstantDiscount, txnAmount) => {
    /* for every paymode change the amount will be calculated again since for different paymodes
     * different discount can be there
     * also if total discount exists then only change the price else keep it existing.
     * eg - like for one paymode it may be discount and for other it may be cashback
     *  */
    if (totalInstantDiscount) {
      const discountPercentage = (totalInstantDiscount / txnAmount) * 100;
      const isEmiSubventionFlow = this.props.cache.getData(
        CONSTANT.IS_EMISUBVENTION_ACCESS_TOKEN_FLOW
      );
      // using stringify and parse since on destructuring also the original object was being changed
      const subventionObject = JSON.parse(
        JSON.stringify(this.props.cache.getData(CONSTANT.SUBVENTION_OBJ_INITIAL))
      );
      const emiStrategy = this.props.cache.getData(CONSTANT.EMISUBVENTION_STATEGY);
      if (isEmiSubventionFlow) {
        if (emiStrategy === EMI_SUBVENTION_STRATEGY.ITEM_BASED) {
          let items = getKey(subventionObject, 'items', []);
          items = items.map(item => {
            item.price -= (discountPercentage / 100) * item.price;
            return item;
          });
          this.props.cache.setData(CONSTANT.SUBVENTION_OBJ, { items });
        } else {
          let { price, subventionAmount } = subventionObject;
          price -= (discountPercentage / 100) * price;
          subventionAmount -= (discountPercentage / 100) * subventionAmount;
          this.props.cache.setData(CONSTANT.SUBVENTION_OBJ, {
            price,
            subventionAmount
          });
        }
      }
      this.props.cache.setData(
        CONSTANT.BANK_OFFER_TXN_AMOUNT,
        money(txnAmount - totalInstantDiscount)
      );
    } else {
      this.props.cache.setData(CONSTANT.BANK_OFFER_TXN_AMOUNT, money(txnAmount));
      this.props.cache.setData(
        CONSTANT.SUBVENTION_OBJ,
        this.props.cache.getData(CONSTANT.SUBVENTION_OBJ_INITIAL)
      );
    }
  };

  /* when a new card is selected set paymode based offers as null since it was showing previously
  selected bank offer and also reset payable amount */
  setEmiOfferNull = () => {
    this.setState({ payModeBasedOffers: {} });
    const fallBackAmount = this.props.cache.getData(CONSTANT.FALLBACK_TXN_AMOUNT);
    if (fallBackAmount) {
      this.props.cache.setData(CONSTANT.TXN_AMOUNT, fallBackAmount);
    }
    this.setPayableAmount();
  };

  render(
    {
      payData,
      wallet,
      mgv,
      selected,
      subscription,
      loginInfo,
      btnText,
      sessionExpired = false,
      stopScroll = false,
      showHelperOverlay = '',
      cache,
      checkoutElementPayMode
      // directBankData = ''
    },
    {
      upiIntentApps,
      showAllSavedCards,
      headerFixClass,
      pcfFeeAmount,
      isPcfEnabled,
      payModeBasedOffers,
      isPromoAvailable,
      mandateAccountDetails,
      qr
    }
  ) {
    const paymentOption = cache.getData('paymentOptions');
    const insufficientBalance = isInsufficientBalance(paymentOption, cache);
    const isMgvBalSufficient = isMgvSufficient(mgv, cache);
    const offers = getKey(payModeBasedOffers, 'offerBreakup');

    let isMgvActive = false;
    if (
      !cache.getData(CONSTANT.CURRENT_PAYMODE) ||
      getKey(cache.getData(CONSTANT.CURRENT_PAYMODE), 'paymentMode') === 'GIFT_VOUCHER'
    ) {
      selected && selected.id && mgv && (isMgvActive = selected.id === mgv.id);
    }

    const hidePaytmBranding = getKey(
      cache.getData(CACHE.MERCHANT_CONFIG),
      'merchant.hidePaytmBranding',
      undefined
    );
    const {
      onOptionSelect,
      updatePcfAmount,
      updateSelectedPayModePcfWithInstId,
      fetchPcf,
      applyPromoForPayMode,
      handlePromoResponseFromCard,
      handlePromoErrorFromCard,
      updatePromoEnableStatus,
      setEmiOfferNull,
      setPayableAmount
    } = this;
    const amountPayable = calculateAmountPayable(
      cache.getData(CONSTANT.TXN_AMOUNT),
      wallet,
      true,
      this.props.subscription
    );
    let toShowSelectOPtionText = true;
    const channels = {
      collectEnabled: false,
      intentEnabled: false,
      pushEnabled: false
    };

    selected && (this.selected = selected.reference);
    payData &&
      payData.paymentModes &&
      payData.paymentModes.map(option => {
        if (option.type === 'upi') {
          option.payChannelOptions &&
            option.payChannelOptions.forEach(channel => {
              switch (channel.channelCode) {
                case 'UPI':
                  channels.collectEnabled = true;
                  break;

                case 'UPIPUSH':
                  channels.intentEnabled = true;
                  break;

                case 'UPIPUSHEXPRESS':
                  channels.pushEnabled = true;
                  break;
                default:
                  break;
              }
            });
        }
        return option;
      });
    const isEmiElementPaymode = equalsIgnoreCase(ELEMENT_PAYMODE.EMI, checkoutElementPayMode);
    const isScanAndPayPaymode = equalsIgnoreCase(
      ELEMENT_PAYMODE.SCAN_AND_PAY,
      checkoutElementPayMode
    );

    return (
      <div
        id="checkout-home"
        class={`${selected && !sessionExpired ? 'ptm-btn-visible' : ''} ptm-main ${
          checkoutElementPayMode ? 'ptm-checkout-element' : ''
        } ${this.isSingleSelection ? 'ptm-single-selection' : ''} ${
          this.hidePaymodeLabel ? 'ptm-no-paymode-label' : ''
        } ${isScanAndPayPaymode ? 'ptm-scan-and-pay-element' : ''}`}
      >
        {checkoutElementPayMode ? (
          <ElementsHeader />
        ) : (
          <Header
            {...{ headerFixClass, isPcfEnabled, pcfFeeAmount }}
            ref={headerComp => {
              this.headerComp = headerComp;
            }}
          />
        )}
        <div
          class={`payment-content-wrap ptm-body-bg ${stopScroll ? 'stop-scroll' : ''} ${
            stopScroll ? 'ptm-hide-btn' : ''
          }`}
          ref={mainComp => {
            this.mainComp = mainComp;
          }}
        >
          {!sessionExpired && (
            /* if hidePaytmBranding is set true then need to add a class to paymodes to prevent
            overlapping of button from last paymode */
            <div class={`payment-mode-warp ${hidePaytmBranding ? 'hide-paytm-branding' : ''}`}>
              {isPromoAvailable && !checkoutElementPayMode && <Offers />}
              {/* svpa and cod */}
              {this.isWeb && qr && qr.enabled && qr.dataUrl && <QRCode qr={qr} />}

              {loginInfo && loginInfo.userLoggedIn && (
                <h4 className="ptm-select-txt ptm-uppercase">
                  {getKey(subscription, 'isEnabled', false)
                    ? this.label.subscriptionSelection
                    : this.label.paymodeSelection}
                </h4>
              )}
              {mgv && mgv.isEnabled && (
                <MGV
                  {...{ isMgvBalSufficient, isMgvActive, onOptionSelect }}
                  ref={k => {
                    mgv.reference = k;
                  }}
                />
              )}
              {loginInfo && loginInfo.userLoggedIn && wallet && (
                <Wallet
                  {...{
                    insufficientBalance,
                    fetchPcf,
                    applyPromoForPayMode,
                    offers,
                    isPromoAvailable,
                    updatePromoEnableStatus
                  }}
                  ref={k => {
                    wallet.reference = k;
                  }}
                />
              )}
              {payData &&
                payData.savedVPas &&
                payData.savedVPas.map(option => {
                  const Paymode = this.components[option.type];
                  toShowSelectOPtionText = false;
                  if (Paymode) {
                    const isActive = !!(selected && selected.id === option.id);
                    return (
                      <Paymode
                        {...{
                          option,
                          channels,
                          isActive,
                          onOptionSelect,
                          amountPayable,
                          offers,
                          updatePcfAmount,
                          updateSelectedPayModePcfWithInstId,
                          applyPromoForPayMode,
                          isPromoAvailable
                        }}
                        ref={k => {
                          option.reference = k;
                        }}
                      />
                    );
                  }
                  return option;
                })}
              {!isEmiElementPaymode &&
                payData &&
                payData.savedInstruments &&
                payData.savedInstruments.length > 0 &&
                loginInfo &&
                !loginInfo.userLoggedIn && (
                  <h4 className="ptm-select-txt ptm-uppercase">{this.label.saveCardSelection}</h4>
                )}
              <div class={`ptm-pay-method-wrap`}>
                {!isEmiElementPaymode &&
                  payData &&
                  payData.savedInstruments &&
                  payData.savedInstruments.map((option, index) => {
                    const Paymode = this.components[option.type];
                    toShowSelectOPtionText = false;
                    let isDisplay = true;
                    if (index > 1 && !showAllSavedCards && loginInfo && !loginInfo.userLoggedIn) {
                      isDisplay = false;
                      this.state.showMoreSavedCardsLink = true;
                    }
                    const isActive = !!(selected && selected.id === option.id);
                    if (Paymode) {
                      return (
                        <Paymode
                          {...{
                            option,
                            offers,
                            channels,
                            upiIntentApps,
                            isDisplay,
                            isActive,
                            onOptionSelect,
                            fetchPcf,
                            applyPromoForPayMode,
                            isPromoAvailable
                          }}
                          ref={k => {
                            option.reference = k;
                          }}
                        />
                      );
                    }
                    return option;
                  })}
                {this.state.showMoreSavedCardsLink && loginInfo && !loginInfo.userLoggedIn && (
                  <p className="ptm-small-txt-link ptm-cardtxt" onClick={this.showHideSavedCards}>
                    {this.showMoreSavedCardsLinkTxt}
                  </p>
                )}
                {payData &&
                  payData.savedMandateBanks &&
                  payData.savedMandateBanks.map(option => {
                    const Paymode = this.components[option.type];
                    toShowSelectOPtionText = false;
                    if (Paymode) {
                      const isActive = !!(selected && selected.id === option.id);
                      return (
                        <Paymode
                          {...{
                            option,
                            channels,
                            isActive,
                            onOptionSelect,
                            amountPayable,
                            offers,
                            updatePcfAmount,
                            updateSelectedPayModePcfWithInstId,
                            applyPromoForPayMode,
                            isPromoAvailable
                          }}
                          ref={k => {
                            option.reference = k;
                          }}
                        />
                      );
                    }
                    return option;
                  })}
                {loginInfo && !loginInfo.userLoggedIn && toShowSelectOPtionText && (
                  <h4 className="ptm-select-txt ptm-uppercase">
                    {getKey(subscription, 'isEnabled', false)
                      ? this.label.subscriptionSelection
                      : this.label.paymodeSelection}
                  </h4>
                )}
                {loginInfo && !loginInfo.userLoggedIn && !toShowSelectOPtionText && (
                  <h4 className="ptm-select-txt ptm-uppercase">
                    {this.label.paymodeOtherSelection}
                  </h4>
                )}
                {payData &&
                  payData.paymentModes &&
                  payData.paymentModes.map(option => {
                    const Paymode = this.components[option.type];
                    const isActive = !!(selected && selected.id === option.id);
                    if (Paymode && option.isEnabled) {
                      return (
                        <Paymode
                          {...{
                            option,
                            channels,
                            upiIntentApps,
                            isActive,
                            onOptionSelect,
                            offers,
                            updatePcfAmount,
                            updateSelectedPayModePcfWithInstId,
                            applyPromoForPayMode,
                            handlePromoResponseFromCard,
                            isPromoAvailable,
                            handlePromoErrorFromCard,
                            mandateAccountDetails,
                            setEmiOfferNull,
                            setPayableAmount
                          }}
                          ref={k => {
                            option.reference = k;
                          }}
                        />
                      );
                    }
                    return option;
                  })}
              </div>
            </div>
          )}
          {sessionExpired && <Timeout />}
          {/* {((selected && !(selected.id == 'loginInfo' && (loginInfo && !loginInfo.userLoggedIn))) ||
            (wallet && wallet.isUsed && !insufficientBalance)) && (
            <Btn onBtnClick={this.onBtnClick} />
          )} */}
          {/* {directBankData && <DirectBank directBankData={directBankData} />} */}
          {!hidePaytmBranding && <Footer />}
        </div>
        {selected && !sessionExpired && <Btn onBtnClick={this.onBtnClick} btnText={btnText} />}
        <Overlay />
        {showHelperOverlay !== '' && (
          <OverlayWrap>
            {showHelperOverlay === CONSTANT.HELPER_TYPE.CVV_HELPER && <CvvHelper />}
            {showHelperOverlay === CONSTANT.HELPER_TYPE.SUBS_DETAILS_HELPER && <Details />}
          </OverlayWrap>
        )}
        <input
          className={`ptm-hidden-input`}
          id={`ptm-hidden-input`}
          ref={r => (this.hiddenInputRef = r)}
          type={`tel`}
        />
      </div>
    );
  }
}
export default connect(
  `payData, wallet, mgv,selected, loginInfo,btnText, subSelected, stopScroll,
  sessionExpired, showHelperOverlay, subscription, cache, checkoutElementPayMode, directBankData`,
  onChange
)(Home);



// WEBPACK FOOTER //
// ./components/home/index.js